import { configureStore } from '@reduxjs/toolkit';
import reportSlice from './report-slice';
import activitySlice from './activity-slice';
import memberSlice from './member-slice';
import leaveSlice from './leave-slice';
import holidaySlice from './holiday-slice';
import dashboardSlice from './dashboard-slice';
import userSlice from './user-slice';
import userPageSlice from './user-page-slice';
import clientSlice from './client-slice';
import clientPageSlice from './client-page-slice';
import managerSlice from './manager-slice';
import managerPageSlice from './manager-page-slice';
import clientMappingPageSlice from './client-mapping-page-slice';
import memberReportingSlice from './member-reporting-slice';
import memberPageSlice from './member-page-slice';
import memberReportingPageSlice from './member-reporting-page-slice';
import skillSlice from './skill-slice';
import iqmsSlice from './iqms-slice';
import projectSlice from './project-slice';
import knowledgeSlice from './knowledge-slice';
import departmentSlice from './department-slice';

const store = configureStore({
    reducer: {
        dashboard: dashboardSlice.reducer,
        report: reportSlice.reducer,
        activity: activitySlice.reducer,
        member: memberSlice.reducer,
        leave: leaveSlice.reducer,
        holiday: holidaySlice.reducer,
        user: userSlice.reducer,
        userPage: userPageSlice.reducer,
        department: departmentSlice.reducer,
        client: clientSlice.reducer,
        clientPage: clientPageSlice.reducer,
        manager: managerSlice.reducer,
        managerPage: managerPageSlice.reducer,
        clientMappingPage: clientMappingPageSlice.reducer,
        memberReporting: memberReportingSlice.reducer,
        memberPage: memberPageSlice.reducer,
        memberReportingPage: memberReportingPageSlice.reducer,
        skill: skillSlice.reducer,
        iqms: iqmsSlice.reducer,
        project: projectSlice.reducer,
        knowledge: knowledgeSlice.reducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false
      }),
});

export default store;